import { useQuery } from '@tanstack/react-query';

import { getProjectTemplates } from '~/services/ContractingService';

export const projectTemplateQueryKeys = {
  all: ['project-templates'] as const,
  lists: () => [...projectTemplateQueryKeys.all, 'list'] as const,
};

export function useGetProjectTemplates({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: projectTemplateQueryKeys.lists(),
    queryFn: ({ signal }) => getProjectTemplates({ signal }),
    staleTime: Infinity,
    enabled,
  });
}
